/**
 * Globales Recherche-Panel (v3-Entscheidung): 1× Google-Recherche je Produkt
 * als Fakten-Basis für ALLE Channel-Texte — kein Toggle mehr je Channel
 * (Mock-Referenz: orangenes Panel oberhalb der Channel-Liste).
 */

import { useTranslation } from 'react-i18next'

import { Switch } from '@/components/v2/ui'
import { EID } from '@/lib/element-ids.registry'

interface ResearchPanelProps {
  productCount: number
  enabled: boolean
  onChange: (enabled: boolean) => void
}

export function ResearchPanel({ productCount, enabled, onChange }: ResearchPanelProps) {
  const { t } = useTranslation()

  return (
    <div className="text-bulk-wizard-research flex items-start justify-between gap-4 rounded-lg border border-orange-300 bg-orange-50 p-4 dark:border-orange-800 dark:bg-orange-950/20">
      <Switch
        id={EID['text-bulk-wizard-research-toggle']}
        checked={enabled}
        onCheckedChange={onChange}
        label={t('channelContent.wizard.research.title')}
        helperText={t('channelContent.wizard.research.hint')}
      />
      <span className="whitespace-nowrap text-sm font-medium text-orange-700 dark:text-orange-400">
        {t('channelContent.wizard.research.counter', { count: productCount })}
      </span>
    </div>
  )
}
